import { render, staticRenderFns } from "./ImagePrivate.vue?vue&type=template&id=69d213ca&scoped=true&"
import script from "./ImagePrivate.vue?vue&type=script&lang=ts&"
export * from "./ImagePrivate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d213ca",
  null
  
)

export default component.exports